import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PupilApp } from "./pupil/PupilApp";
import { registerServiceWorker } from "./registerServiceWorker";

const root = document.getElementById("root");

if (root === null) {
  throw new Error("Application root is missing");
}

createRoot(root).render(
  <StrictMode>
    <PupilApp />
  </StrictMode>,
);

void registerServiceWorker({
  buildId: __MOON_PHASES_BUILD_ID__,
  production: import.meta.env.PROD,
  secureContext: window.isSecureContext,
  hostname: window.location.hostname,
});
